//http://facebook.github.io/fixed-data-table/
import React from 'react';
import FixedDataTable from 'fixed-data-table';
import BaseReactComponent from '../Util/BaseReactComponent';
import styles from './DataTable.scss';
import baseComponent from '../../decorators/baseComponent';
import RaisedButton from 'material-ui/RaisedButton';

var Table = FixedDataTable.Table;
var Column = FixedDataTable.Column;

var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC'
};

//const LinkCell = ({rowIndex, rowGetter, columnKey, ...props}) => (
//  <Cell {...props}>
//    {rowGetter(rowIndex)[columnKey]}
//  </Cell>
//);

const editCell = function (cellData, cellDataKey, rowData) {
  return <div>{rowData.edit}</div>;
};

@baseComponent(styles)
class DataTable extends BaseReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      rows: props.rows || [],
      tableWidth: props.tableWidth || 1155,
      tableHeight: 568,
      filteredRows: [],
      filterBy: undefined,
      sortBy: props.sortBy,
      sortDir: undefined,
      size: 2000,
      cache: []
    };
  }

  componentWillReceiveProps(newProps) {
    if (this.state.sortBy === undefined && newProps.cols[0]) {
      let sortBy = newProps.cols[0];
      if (sortBy instanceof Object) {
        sortBy = sortBy.id;
      }
      this.setState({ sortBy });
      this.filterAndSort(newProps.rows, this.state.filterBy, sortBy, this.state.sortDir);
    }

    if (this.props.rows !== newProps.rows) {
      this.filterAndSort(newProps.rows, this.state.filterBy, this.state.sortBy, this.state.sortDir);
    }

    this.setState({
      tableWidth: this.props.tableWidth || 1155,
      tableHeight: 568,
      size: 2000,
      cache: []
    });
  }

  componentDidMount() {
    this.update();
    const win = window;
    if (win.addEventListener) {
      win.addEventListener('resize', this.onResize, false);
    } else if (win.attachEvent) {
      win.attachEvent('onresize', this.onResize);
    } else {
      win.onresize = this.onResize;
    }
  }

  onSortByChange = cellDataKey => {
    var sortDir = this.state.sortDir;
    var sortBy = cellDataKey;
    if (sortBy === this.state.sortBy) {
      sortDir = this.state.sortDir === SortTypes.ASC ? SortTypes.DESC : SortTypes.ASC;
    } else {
      sortDir = SortTypes.DESC;
    }

    this.setState({ sortBy, sortDir });
    this.filterAndSort(this.props.rows, this.state.filterBy, sortBy, sortDir);
  };

  filterAndSort = (rows, filterBy, sortBy, sortDir) => {
    var filteredRows = filterBy
      ? rows.filter(function (row) {
        for (let field in row) {
          if (typeof row[field] === 'string' && row[field].toLowerCase().indexOf(filterBy.toLowerCase()) >= 0) {
            return true;
          } else if (row[field] == filterBy) {
            // eslint-disable-line eqeqeq
            return true;
          }
        }
        return false;
      })
      : rows;
    if (sortBy) {
      let sortFunc;
      this.props.cols.forEach(col => {
        if (col.id && col.id === sortBy) {
          sortFunc = col.sort;
        }
      });


      filteredRows = filteredRows.sort((a, b) => {
        if (sortFunc) {
          return sortFunc(a, b, sortBy, sortDir);
        }

        var sortVal = 0;
        if (a[sortBy] > b[sortBy]) {
          sortVal = 1;
        }
        if (a[sortBy] < b[sortBy]) {
          sortVal = -1;
        }

        if (sortDir === SortTypes.DESC) {
          sortVal = sortVal * -1;
        }

        return sortVal;
      });
    }

    this.setState({ filteredRows });
  };

  renderHeader(label, cellDataKey) {
    return <a onClick={this.onSortByChange.bind(this, cellDataKey)}>{label}</a>;
  }

  onFilterChange(e) {
    const filterBy = e.target.value;
    this.setState({ filterBy });
    this.filterAndSort(this.props.rows, filterBy, this.state.sortBy, this.state.sortDir);
  }

  onResize() {
    clearTimeout(this._updateTimer);
    this._updateTimer = setTimeout(this.update, 16);
  }

  update() {
    this.setState({
      tableWidth: 1155,
      tableHeight: 5000
    });
  }

  onEditClick(row) {
    this.props.onEdit(row);
  }

  rowGetter(rowIndex) {
    let row = this.state.filteredRows[rowIndex];
    row.edit = row.delete = (
      <RaisedButton
        buttonStyle={{ padding: '0 16px' }}
        className="edit-button"
        backgroundColor="#E2171A"
        labelColor="#FFFFFF"
        onClick={this.onEditClick.bind(this, row)}>
        {this.getIntlMessage('global.edit')}
      </RaisedButton>
    );

    if (row.beta === true || row.beta === false) {
      row.beta2 = this.getIntlMessage(('global.' + row.beta).toLowerCase());
    }

    if (row.country !== undefined) {
      row.country2 = this.getIntlMessage('country.' + row.country.toUpperCase());
    }

    if (row.product && row.product.name) {
      row.productName = row.product.name;
    }

    return row;
  }

  addNew() {
    this.props.onAddNew();
  }

  render() {
    var sortDirArrow = '';

    if (this.state.sortDir !== null) {
      sortDirArrow = this.state.sortDir === SortTypes.DESC ? ' ▼' : ' ▲';
    }

    let self = this;
    let columns = this.props.cols.map(function (c, i) {
      let column;

      let name = c.id !== undefined ? c.id : c;

      if (name !== 'edit' || name !== 'delete') {
        column = (
          <Column
            key={i}
            label={self.getMessage('table-headers.' + name) + (self.state.sortBy === name ? sortDirArrow : '')}
            headerRenderer={self.renderHeader.bind(self)}
            headerClassName="DataTable-header"
            flexGrow={1}
            dataKey={name}
            width={c.width || 200}
          />
        );
      } else {
        column = (
          <Column
            key={i}
            label={self.getMessage('table-headers.' + name) + (self.state.sortBy === name ? sortDirArrow : '')}
            headerRenderer={self.renderHeader.bind(self)}
            headerClassName="DataTable-header"
            flexGrow={1}
            dataKey={name}
            width={c.width || 200}
            cellRenderer={editCell.bind(self)}
          />
        );
      }

      return column;
    });

    return (
      <div className="DataTable">
        <div className="controls clearfix">
          <div className="container controls">
            <div className="DataTable-filter col-xs-6 col-sm-9">
              <input
                onChange={this.onFilterChange.bind(this)}
                placeholder={this.getMessage('filter-placeholder')}
                className="col-sm-7"
              />
              <span className="glyphicon glyphicon-search" />
            </div>
            <div className="col-xs-6 col-sm-3">
              <RaisedButton
                labelColor="#FFFFFF"
                backgroundColor="#E2171A"
                className="add-new-button"
                onTouchTap={this.addNew.bind(this)}
                label={this.getMessage('add-new-button')}
              />
            </div>
          </div>
        </div>
        <br />

        <div className="table-container">
          <div className="container">
            <div className="col-xs-12">
              <Table
                rowHeight={80}
                rowGetter={this.rowGetter.bind(this)}
                rowsCount={this.state.filteredRows.length}
                width={this.state.tableWidth}
                height={this.state.filteredRows.length * 80 + 52 + 35}
                headerHeight={50}>
                {columns}
              </Table>
              {this.state.filteredRows.length === 0 ? (
                <div>{this.getIntlMessage('table.no-data-message')}</div>
              ) : (
                  <div />
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DataTable.propTypes = {
  cols: React.PropTypes.array,
  rows: React.PropTypes.array,
  onAddNew: React.PropTypes.func,
  onEdit: React.PropTypes.func,
  sortBy: React.PropTypes.string
};

export default DataTable;

//<Column label={'username' + (this.state.sortBy === 'username' ? sortDirArrow : '')} headerRenderer={this.renderHeader.bind(this)} headerClassName="DataTable-header" flexGrow={1} dataKey='username' width={200}/>
//<Column label="Col 2" headerRenderer={this.renderHeader.bind(this)} headerClassName="DataTable-header" flexGrow={1} dataKey={1} width={200}/>



// WEBPACK FOOTER //
// /src/components/DataTable/DataTable.js